import React, { useState } from 'react';
import Rodal from '../../Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import ReactSwitch from 'react-switch';
import SellerProfileWrapper from '../SellerProfileWrapper/SellerProfileWrapper';
import { MarketplaceSellerProfile } from '../../../slices/profiles-data-slice/models/marketplace-seller-profile';
import './PreviewProfileModal.scss';

interface PreviewProfileModalProps {
    isVisible: boolean;
    onClose(): void;
    profileData?: MarketplaceSellerProfile;
}

const PreviewProfileModal = (props : PreviewProfileModalProps) => {
    const [isDisclosed, setIsDisclosed] = useState(false);
    const { profileData } = props;

    return (
        <div className="preview-profile-modal">
            <Rodal
                visible={props.isVisible}
                onClose={() => props.onClose()}
                width={isDisclosed ? 1200 : 600}
                showMask={false}
                animation="fade"
                closeMaskOnClick={false}>
                <ModalHeader>
                    <div className="modal-header-content">
                        <span>Preview Profile</span>
                        <div className="switch-container">
                            <div className="current-option">
                                <span className="current-text">Anonymized</span>
                            </div>
                            <ReactSwitch
                                checked={isDisclosed}
                                onChange={(checked) => setIsDisclosed(checked)}
                                height={22}
                                handleDiameter={16}
                                onColor="#535bd6"
                                offColor="#535bd6"
                                checkedIcon={false}
                                uncheckedIcon={false}
                            />
                            <div className="coming-soon-option">
                                <span className="coming-soon-text">Disclosed</span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <SellerProfileWrapper
                        isDisclosed={isDisclosed}
                        profileData={profileData}
                    />
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default PreviewProfileModal;
